<ng-content select="header"></ng-content>
<ng-content select="main"></ng-content>
<ng-content></ng-content>
